import { Box, Paper } from "@mui/material";
import Header from "../../components/global/Header";
import React, { useEffect } from "react";
import { HeadCells } from "../../data/FaqData";
import axios from "axios";
import Table from "../../components/global/TableComponent";
import FormComponent from "../../components/global/FormComponent";
import Swal from "sweetalert2";
import Popup from "../../components/global/PopUp";
import toast, { Toaster } from "react-hot-toast";
import { useState } from "react";
import Error404 from "../../pages/Error404";

const formConfig = [
  {
    field: {
      type: "text",
      title: "Question",
      name: "question",
      placeholder: "Write Question",
      required: true,
      error: {
        condition: (value) => value.trim() === "",
        message: "Question is required",
      },
    },
  },
  {
    field: {
      type: "text",
      title: "Answer",
      name: "answer",
      placeholder: "Provide Answer",
      required: true,
      error: {
        condition: (value) => value.trim() === "",
        message: "Answer is required",
      },
    },
  },
];

function FAQ({ role }) {
  const [openPopup, setOpenPopup] = useState(false);
  const [editId, setEditId] = useState(null);
  const [edit, setEdit] = useState(false);
  const [faqs, setFaqs] = useState([]);

  const isEdit = editId != null;
  const formFieldValues = isEdit ? editId : null;
  console.log(isEdit);
  console.log("heeeeeeeee", formFieldValues);
  console.log("EDit", edit);

  const handleAdd = async (formData) => {
    console.log("Form Data:", formData);

    try {
      // Make a POST request to the backend endpoint
      const response = await axios.post(
        "http://127.0.0.1:8000/admins/create-faq",
        formData
      );

      // Handle response based on server's response
      if (response.status === 200) {
        // Handle successful creation of user
        console.log("FAQ Added successfully:", response.data.user);
        GetFAQs();

        // Redirect user or show a success message
      } else {
        // Handle other status codes or errors
        console.error("Error:", response.data);
        // Display an error message to the user
      }
    } catch (error) {
      console.error("Error:", error);
      // Handle network errors or other exceptions
      // Display an error message to the user
    }
    setOpenPopup(false);
  };

  const handleUpdate = async (formData) => {
    console.log("Hello");

    console.log("Form Data:", formData);

    try {
      // Make a POST request to the backend endpoint
      const response = await axios.post(
        "http://127.0.0.1:8000/admins/update-faq",
        formData
      );

      // Handle response based on server's response
      if (response.status === 200) {
        // Handle successful creation of user
        console.log("FAQ Updated successfully:", response.data.user);
        // Redirect user or show a success message
        GetFAQs();
      } else {
        // Handle other status codes or errors
        console.error("Error:", response.data);
        // Display an error message to the user
      }
    } catch (error) {
      console.error("Error:", error);
      // Handle network errors or other exceptions
      // Display an error message to the user
    }

    // updateFaqRecord(formData);
    setEdit(false);
    setOpenPopup(false);
  };

  const deleteRecord = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          // Pass the data in an object
          const response = await axios.delete(
            "http://127.0.0.1:8000/admins/delete-faq",
            { data: { FaQ_id: id } }
          );
          if (response.status === 200) {
            toast.success("Successfully deleted the record");
            GetFAQs();
          } else {
            toast.error("Operation not Completed", response.data);
          }
        } catch (error) {
          toast.error("Operation not Completed");
        }
      }
    });
  };

  useEffect(() => {
    GetFAQs();
    return () => {
      // Cleanup code, if needed
    };
  }, []);
  const GetFAQs = async () => {
    try {
      const response = await axios.get(
        "http://127.0.0.1:8000/admins/get-all-faqs"
      );

      if (response.status === 200) {
        console.log("FAQs fetched successfully:", response.data.faqs);

        const modifiedFaqs = response.data.faqs.map((faq) => ({
          id: faq.FaQ_id,
          question: faq.question,
          answer: faq.answer,
        }));
        console.log("modified are ", modifiedFaqs);
        setFaqs(modifiedFaqs);
      } else {
        console.error("Error:", response.data);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
    <>
      {role === "admin" ? (
        <Box m={"2vw"}>
          <Header
            title="FAQ"
            subTitle="List of all the frequently asked questions related to the trading bot"
          />
          <Paper style={{ background: "#201939eb", padding: "2vh 2vw" }}>
            <Table
              tableHeaders={HeadCells}
              data={faqs}
              buttons={[
                { btnName: "Edit", bg: "var(--iris-60)" },
                { btnName: "Delete", bg: "var(--red)" },
              ]}
              addButton={true}
              addAction={() => setOpenPopup(true)}
              setEditId={setEditId}
              setEdit={setEdit}
              deleteRecord={deleteRecord}
            />
          </Paper>
          {edit ? (
            <Popup
              title="Edit FAQ"
              openPopup={openPopup}
              setOpenPopup={setOpenPopup}
              setEdit={setEdit}
            >
              <FormComponent
                formConfig={formConfig}
                buttonText={"update"}
                closePopup={() => setOpenPopup(false)}
                handleAddOrUpdate={handleUpdate}
                fieldValue={formFieldValues}
              />
            </Popup>
          ) : (
            <Popup
              title="Add FAQ"
              openPopup={openPopup}
              setOpenPopup={setOpenPopup}
            >
              <FormComponent
                formConfig={formConfig}
                buttonText={"add"}
                closePopup={() => setOpenPopup(false)}
                handleAddOrUpdate={handleAdd}
                fieldValue={null}
              />
            </Popup>
          )}
          <Toaster />
        </Box>
      ) : (
        <Error404 />
      )}
    </>
  );
}

export default FAQ;
